module.exports = __webpack_public_path__ + "static/media/previousArrow.471ec7eb.svg";